/**
 * @summary - Component that Provides PPM Planner Repository 
 * @autor vengateshwaran k
 * @since 2024-06-21
 */
import { BemsGraph, FemsGraph,MasterGraph } from "../../utility/apiURLS";
import Axios from '../data-access/genericAxios';
import  ReArrangeLabel  from "../../components/commoncomponents/ReArrangeLabel";

async function getPPMChecklistList(facilityId) {
  const response = await Axios.get(`${FemsGraph}/api/PPMChecklist/GetListPPMChecklist/${facilityId}?page=1&size=3000`);
  return response;
}
async function getBemsPPMChecklistList(facilityId) {
    const response = await Axios.get(`${BemsGraph}/api/PPMChecklist/GetListPPMChecklist/${facilityId}?page=1&size=3000`);
       return response;
  }

  async function getPPMChecklistListForExport(facilityId) {
    const response = await Axios.get(`${FemsGraph}/api/PPMChecklist/GetCommonExportPPM/${facilityId}?filterOptions=[]&sortOptions=[]`);
    return response;
  }
  async function getBemsPPMChecklistListForExport(facilityId) {
      const response = await Axios.get(`${BemsGraph}/api/PPMChecklist/GetCommonExportPPM/${facilityId}?filterOptions=[]&sortOptions=[]`);
         return response;
    }
async function getTypeCode(companyid,serviceId,classificationId) {
    const response = await Axios.get(`${MasterGraph}/api/GraphMasassettypecode/GetMasassettypecodeAndCompanyId/${companyid}/${serviceId}/${classificationId}?size=3000`);
    if(response?.status !== 'error'){
   const reArrangedData=ReArrangeLabel(response?.data,"typecode","label"); 
    return reArrangedData;
    }
    return response;
  }

  async function getBemsTypeCode(MasservicedetailsId) {
    
    const response = await Axios.get(`${BemsGraph}/api/PPMChecklist/GetAssettypecodebyService/${MasservicedetailsId}?size=3000`);
       if(response?.status !== 'error'){
        const reArrangedData=ReArrangeLabel(response?.data,"typecode","label"); 
        return reArrangedData;
    }
    return response;
  }


  async function getTaskCode(Facilityid) {
    
    const response = await Axios.get(`${FemsGraph}/api/PPMChecklist/GetTaskcodebyService/${Facilityid}?size=3000`);
       if(response?.status !== 'error'){
   const reArrangedData=ReArrangeLabel(response?.data,"taskcode","label"); 
    return reArrangedData;
    }
    return response;
  }
  async function getBemsTaskCode(Facilityid) {
    
    const response = await Axios.get(`${BemsGraph}/api/PPMChecklist/GetTaskcodebyService/${Facilityid}?size=3000`);
       if(response?.status !== 'error'){
   const reArrangedData=ReArrangeLabel(response?.data,"taskcode","label"); 
    return reArrangedData;
    }
    return response;
  }

  async function getBemsAssetClassification(Facilityid) {
    
    const response = await Axios.get(`${BemsGraph}/api/bemassetclassifications?size=3000`);
       if(response?.status !== 'error'){
   const reArrangedData=ReArrangeLabel(response?.data,"assetclassification","label"); 
    return reArrangedData;
    }
    return response;
  }

  async function getPPMChecklistNo(Facilityid,token) {    
    const response = await Axios.get(`${MasterGraph}/api/GraphDocumentSerialNumber/GetDocumentSerialNumberDetails/${Facilityid}/CKL/${token}?size=3000`);
     return response?.data;
  }

  async function getAssetClassification(Facilityid) {
    const response = await Axios.get(`${FemsGraph}/api/femassetclassifications?size=3000`);
       if(response?.status !== 'error'){
   const reArrangedData=ReArrangeLabel(response?.data,"assetclassification","label"); 
    return reArrangedData;

    }
    return response;
  }
  async function createPPMCheckList(item) { 
    const response = await Axios.post(`${FemsGraph}/api/femppmchecklists`,item); 
     return response;
   }
   async function createBemsPPMCheckList(item) { 
    const response = await Axios.post(`${BemsGraph}/api/femppmchecklists`,item); 
     return response;
   }
 async function removePpmCheckList(id) { 
  const response = await Axios.remove(`${FemsGraph}/api/femppmchecklists/${id}`); 
   if(response?.status !== 'error'){
 
   }
   return response;
 }
 async function removeBemsPpmCheckList(id) { 
    const response = await Axios.remove(`${BemsGraph}/api/bemppmchecklists/${id}`); 
     if(response?.status !== 'error'){
   
     }
     return response;
   }

const PPMCheckListRepository = {
    getPPMChecklistList,
    getBemsPPMChecklistList,
    getTypeCode,
    getBemsTypeCode,
    getTaskCode,
    createPPMCheckList,
    createBemsPPMCheckList,
    removePpmCheckList,
    removeBemsPpmCheckList,
    getBemsTaskCode,
    getBemsAssetClassification,
    getAssetClassification,
    getPPMChecklistNo,
    getPPMChecklistListForExport,
    getBemsPPMChecklistListForExport

    };   
export default PPMCheckListRepository;
    